import { render, staticRenderFns } from "./WhatsappTemplateList.vue?vue&type=template&id=ef83f086&scoped=true"
import script from "./WhatsappTemplateList.vue?vue&type=script&lang=js"
export * from "./WhatsappTemplateList.vue?vue&type=script&lang=js"
import style0 from "./WhatsappTemplateList.vue?vue&type=style&index=0&id=ef83f086&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef83f086",
  null
  
)

export default component.exports